/* eslint-disable complexity */
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

interface IProps<T> {
    desktop: T,
    sDesktop?: T,
    laptop?: T,
    tablet?: T,
    mobile?: T,
}

/**
 * Проверяет ширину экрана и возвращает значение соответствующее текущему брейкпоинту
 * обязательно только значение для desktop, остальные можно опускать
 * пример: если мобильная ширина - вернет значение переданное для мобилки
 */
export const useValueByBreakpoint = <T>({
    desktop,
    sDesktop,
    laptop,
    tablet,
    mobile,
}: IProps<T>): T => {
    const isSDesktop = useMatchMediaByWidth(sDesktop ? wideBreakpoints.sDesktop : '');
    const isLaptop = useMatchMediaByWidth(laptop ? wideBreakpoints.laptop : '');
    const isTablet = useMatchMediaByWidth(tablet ? wideBreakpoints.tablet : '');
    const isMobile = useMatchMediaByWidth(mobile ? wideBreakpoints.mobile : '');

    switch (true) {
        case (isMobile && !!mobile):
            return mobile || desktop;
        case (isTablet && !!tablet):
            return tablet || desktop;
        case (isLaptop && !!laptop):
            return laptop || desktop;
        case (isSDesktop && !!sDesktop):
            return sDesktop || desktop;
        default:
            return desktop;
    }
};
